export default {
  preview: 'Preview',
  move: 'Move the picture',
  rect: 'Rectangle',
  point: 'Tracing point',
  polygon: 'Polygon',
  polyline: 'Broken line',
  bezier: 'Curve area',
  bezierline: 'Curve',
  magicmode: 'Magic',
  unmagic: 'Anti-magic',
  complete: 'Finish',
  delete: 'Delete',
  recall: 'Revoke',
  recall2: 'Inverted revoke',
  clear: 'Clear annotation',
  reset: 'Reset picture',
  filstyNor: 'Annotation color',
  filstySP: 'Choose color-line',
  filstySPs: 'Choose color-point',
  pointradius: 'Point size ',
  linewidth: 'Annotation width',
  alpha: 'alpha',
  please: 'Please enter',
  workbanch: 'Workbench',
  radio: 'Single choice',
  checkbox: 'Multiple choice',
  input: 'Gap filling',
  noChoice: 'You did not choose',
  noNull: 'empty',
  lengthErr: 'Length incorrect',
  errorMessage: 'Please check and make sure that all the annotations are finished',
  fitbezier: 'curve fitting',
  fitpoly: 'Fitting a polyline',
  selpoint: 'select the point',
  selset: 'select the set',
  numsize: 'the size of font( order number)',
  pointset: 'point set',
  transparency: 'transparency',
  Threshold: 'threshold',
  movedown: 'move down',
  moveup: 'move up',
  mask: 'mask',
  deletePoint: 'Delete point',
  reset2: 'Reset',
  clear2: 'Clear all',
  tool01: 'Reason for disqualification'
}



// WEBPACK FOOTER //
// ./src/lang/en/public/labelTool.js